import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import Lozenge from '@atlaskit/lozenge/lozenge';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Inline } from '@atlaskit/primitives/compiled/inline';

import { PreviewPanelTitle } from '@atlassian/preview-panel/preview-panel-title';

import { TeamworkGraphPreviewPanelInfoButton } from './TeamworkGraphPreviewPanelInfoButton.tsx';

const styles = cssMap({
	labs: {
		flexShrink: 0,
	},
});

const i18n = defineMessages({
	title: {
		id: 'byline-connections.preview-panel.title-context',
		defaultMessage: 'Context',
		description:
			'Title shown in the preview panel header above work and links related to the current page.',
	},
	labs: {
		id: 'byline-connections.preview-panel.labs',
		defaultMessage: 'Labs',
		description:
			'Lozenge in the Context panel header marking the feature as experimental before general availability.',
	},
});

export const TeamworkGraphPreviewPanelTitle = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Inline alignBlock="center" space="space.025">
			<PreviewPanelTitle title={formatMessage(i18n.title)} />
			<TeamworkGraphPreviewPanelInfoButton />
			<Box xcss={styles.labs}>
				<Lozenge appearance="discovery">{formatMessage(i18n.labs)}</Lozenge>
			</Box>
		</Inline>
	);
};
